// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3kM0f","calendarButtons":"ClockData_calendarButtons__3K0f1"};